export const SkeletonLoader = ({ height = 'h-11', width = 'w-full' }: { height?: string; width?: string }) => {
  return <div className={`${width} ${height} checkout-skeleton-block rounded-md`} />;
};
